import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class Paywall extends BaseModel {
  hasProtectionMandate: boolean;
  hasNotarizedHardCopy: boolean;
  hasVaultPlan: boolean;
  hasDigitalVaultPlan: boolean;
  hasIndividualBasicPlan: boolean;
  hasCouplesBasicPlan: boolean;
  hasSelfServePlan: boolean;
  hasStandardPlan: boolean;
  hasBasicPlan: boolean;
  hasDigitalVaultDocumentBuilder: boolean;
  hasDigitalVaultDocBuilderBasic: boolean;
  hasDigitalVaultDocBuilderOnlineWill: boolean;

  constructor(model: Partial<Paywall> = {}) {
    super();

    this.hasProtectionMandate = model.hasProtectionMandate ?? false;
    this.hasNotarizedHardCopy = model.hasNotarizedHardCopy ?? false;
    this.hasVaultPlan = model.hasVaultPlan ?? false;
    this.hasDigitalVaultPlan = model.hasDigitalVaultPlan ?? false;
    this.hasIndividualBasicPlan = model.hasIndividualBasicPlan ?? false;
    this.hasCouplesBasicPlan = model.hasCouplesBasicPlan ?? false;
    this.hasSelfServePlan = model.hasSelfServePlan ?? false;
    this.hasStandardPlan = model.hasStandardPlan ?? false;
    this.hasBasicPlan = model.hasBasicPlan ?? false;
    this.hasDigitalVaultDocumentBuilder = model.hasDigitalVaultDocumentBuilder ?? false;
    this.hasDigitalVaultDocBuilderBasic = model.hasDigitalVaultDocBuilderBasic ?? false;
    this.hasDigitalVaultDocBuilderOnlineWill = model.hasDigitalVaultDocBuilderOnlineWill ?? false;
  }
}
